<div class="w-full md:px-[3.5rem]">
  <div class="container mx-auto ">

    <div class="bfg-header ">

      <!-- Top utility strip -->
      <div class="topbar ">
        <p-menubar ngSkipHydration [model]="topMenu" styleClass="h-[66px] !px-0 no-list-styling">
          <ng-template pTemplate="start">
            <div class="top-left">
              <a (click)="goHome()" target="_self" class="hidden md:block cursor-pointer">
                <img src="FS_BFG_Logo_Horz_Color.png" alt="Bidding For Good Logo" class="h-12 md:h-14 w-auto" />
              </a>

            </div>
          </ng-template>

          <ng-template pTemplate="end">
            <div class="flex items-center">
              <a class="util-link hidden md:block !text-[rgba(30,72,84,1)]" [routerLink]="['/']">
                <fa-icon [icon]="icons.faHouse" class="text-current"></fa-icon><span class="text-lg">Home</span>
              </a>

              <button type="button" class="util-link hidden md:block !text-[rgba(30,72,84,1)]"
                (click)="onFavoritesClick()">
                <i class="pi pi-bookmark-fill"></i><span class="text-lg">Favorites</span>
              </button>

              <button type="button" class="util-link !text-[rgba(30,72,84,1)]" (click)="onAuctionsClick()">
                <span class="icon-gavel" aria-hidden="true"></span>
                <span class="text-lg">Auctions</span>
              </button>

              @if (!isAuthenticated()) {
              <button pButton label="Sign In" (click)="openLoginModal()"
                class="h-9 p-button-primary sign-in-btn hidden md:block !font-noto-serif">
              </button> } @else {

              <!-- Tiered menu trigger + overlay -->
              <button pButton type="button" class="p-button-text p-button-rounded profile-btn" [outlined]="true"
                (click)="$event.stopPropagation(); accountMenu.toggle($event)" aria-haspopup="true"
                aria-controls="accountMenuPanel">
                <i class="pi pi-user-fill"></i>
                <span class="ml-2 hidden md:inline">Welcome, {{userName()}}</span>
                <i class="pi pi-chevron-down ml-2"></i>
              </button>

              <p-tieredMenu #accountMenu [model]="loggedInItems()" [popup]="true" appendTo="body" [baseZIndex]="12000"
                id="accountMenuPanel" styleClass="account-menu">
                <ng-template #item let-item let-root="root">
                  <ng-container [ngSwitch]="item.id">
                    <ng-container *ngSwitchCase="'SignOut'">
                      <p-button type="button" label="Sign Out" (click)="logout()" [rounded]="true"
                        styleClass="signout-btn h-9 px-6 w-auto text-sm">
                      </p-button>
                    </ng-container>

                    <a *ngSwitchDefault pRipple class="flex items-center p-menubar-item-link">
                      <fa-icon *ngIf="item.icon" [icon]="getIcon(item.icon)" />
                      <span>{{ item.label }}</span>
                      <i *ngIf="item.items" [ngClass]="['ml-auto pi', root ? 'pi-angle-down' : 'pi-angle-right']"></i>
                    </a>
                  </ng-container>
                </ng-template>

              </p-tieredMenu>
              }

            </div>
          </ng-template>
        </p-menubar>
      </div>
      <hr class="hidden md:block mx-[-60px] bg-[--bfg-border] h-[2px]" />
      <!-- Logo + Search -->
      <div class="grid brand-search">
        <div class="dual-grid grid-cols-2 grid mt-2 md:mt-3">
          <div class="brand flex items-center justify-center">
            <ng-container>


              <div class="hidden md:flex justify-center items-center gap-6">
                <button type="button" class="util-link flex justify-center items-center text-lg "
                  (click)="onRunAuctionClick()">
                  <span class="icon-auctionhand"></span>
                  <span class="text-[var(--dark-teal)] font-medium ml-2">Run an Auction</span>
                </button>

                <a class="util-link text-[var(--dark-teal)] cursor-pointer" (click)="onHelpClick()">
                  <fa-icon [icon]="icons.faCircleQuestion"></fa-icon>
                  <span class="ml-2">Help</span>
                </a>
              </div>

            </ng-container>

            <a (click)="goHome()" target="_self" class="block md:hidden">
              <img src="FS_BFG_Logo_Horz_Color.png" alt="Bidding For Good Logo"
                class="h-10 w-28 object-contain flex justify-center cursor-pointer" />
            </a>

          </div>

          <div class="mobile-actions flex items-center justify-between md:hidden">
            @if (!isAuthenticated()) {
            <p-menu #usermenu [model]="userMenu" [popup]="true" class="flex justify-center" appendTo="body"
              id="userMenuPanel" [autoZIndex]="true" [baseZIndex]="11000" styleClass="user-menu">

              <ng-template #item let-item let-root="root">
                <ng-container [ngSwitch]="item.id">
                  <ng-container *ngSwitchCase="'SignIn'">
                    <p-button (click)="openLoginModal()" severity="info"
                      styleClass="hamburger-signin-btn h-9 px-6 text-sm">
                      <fa-icon [icon]="icons.faUser" /> Sign In
                    </p-button>
                  </ng-container>
                  <ng-container *ngSwitchCase="'Register'">
                    <p-button (click)="openRegister()" severity="info"
                      styleClass="hamburger-register-btn h-9 px-6 text-sm">
                      <fa-icon [icon]="icons.faUser" /> Register
                    </p-button>
                  </ng-container>
                </ng-container>
              </ng-template>
            </p-menu>

            <button pButton type="button" class="p-button-text p-button-rounded profile-btn" [outlined]="true"
              (click)="onUserMenuClick($event, false)" aria-label="User">
              <span class="icon-user" aria-hidden="true"></span>
            </button>
            } @else {

            <p-tieredMenu #userlogoutmenu [model]="loggedInItems()" [popup]="true" class="flex justify-center"
              appendTo="body" id="userlogoutMenuPanel" [autoZIndex]="true" [baseZIndex]="11000" styleClass="user-menu">
              <ng-template #item let-item let-root="root">
                <ng-container [ngSwitch]="item.id">
                  <ng-container *ngSwitchCase="'SignOut'">
                    <p-button type="button" label="Sign Out" (click)="logout()" severity="info" [rounded]="true"
                      styleClass="hamburger-logout-btn h-9 px-6 text-sm">
                    </p-button>
                  </ng-container>


                  <a *ngSwitchDefault pRipple class="flex items-center p-menubar-item-link">
                    <fa-icon *ngIf="item.icon" [icon]="getIcon(item.icon)" />
                    <span>{{ item.label }}</span>
                    <i *ngIf="item.items" [ngClass]="['ml-auto pi', root ? 'pi-angle-down' : 'pi-angle-right']"></i>
                  </a>
                </ng-container>
              </ng-template>


            </p-tieredMenu>

            <button pButton type="button" class="p-button-text p-button-rounded profile-btn" [outlined]="true"
              (click)="onUserMenuClick($event, true)" aria-label="User">
              <span class="icon-user" aria-hidden="true"></span>
            </button>

            }
            <p-menu #hamburgerMenuItems [model]="hamburgerMenu" [popup]="true" appendTo="body" [autoZIndex]="true"
              [baseZIndex]="11000">
            </p-menu>
            <button pButton (click)="onHamburguerMenuClick($event, isAuthenticated())" type="button"
              class="hamburger-menu p-button-text p-button-rounded profile-btn" [outlined]="true" aria-label="Menu">
              <i class="pi pi-bars"></i>
            </button>
          </div>
          <div class="search-wrap rounded">
            <div class="search-row flex items-stretch gap-2 shadow-none">


              <form class="flex flex-1 items-stretch gap-0" (submit)="onSearchSubmit($event)">
                  <p-iconfield 
                    class="custom-icon-field flex-1 min-w-0 
                          !border !border-[var(--community-info-500)] 
                          rounded-l-md border-r-0 h-9">

                    <p-inputicon>
                      <span class="text-[var(--community-info-500)] pi pi-search"></span>
                    </p-inputicon>

                    <input 
                      pInputText
                      class="!border-none w-full min-w-0 h-full 
                            leading-[36px] px-2 DMSans text-dm-sans"
                      name="q"
                      [(ngModel)]="searchTerm"
                      [placeholder]="isMobile() ? 'Search' : 'Search auctions and items'"
                      aria-label="Search" />
                  </p-iconfield>

                  <button 
                    pButton 
                    type="submit" 
                    label="Search"
                    class="h-9 !rounded-l-none !rounded-r-md font-bold px-4 
                          !bg-[var(--community-info-500)] 
                          !border !border-[var(--community-info-500)] 
                          border-l-0 -ml-[1px] flex items-center justify-center">
                  </button>

                </form>

              <!-- keep this OUTSIDE the <form> so it doesn’t submit -->
              <div class="hidden md:block">
                <button pButton
                  class="p-button-primary text-white h-9 px-4 whitespace-nowrap min-w-[11rem] flex items-center gap-0.5 !bg-[var(--community-info-500)] !border-[var(--community-info-500)]"
                  style="--p-button-gap: 0.0rem" type="button" (click)="browseMenuRef.toggle($event)">
                  <!-- inline SVG -->

                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20"
                    preserveAspectRatio="xMidYMid meet"
                    class="w-6 h-6 fill-current flex-shrink-0 block -translate-y-[1px]" aria-hidden="true">
                    <g transform="translate(1.2 3.5) scale(1.05)">
                      <path
                        d="M3.4334383 4.7043748L2.9659383 4.2368751C2.6534383 3.9243751 2.6534383 3.4168749 2.9659383 3.1043749L5.8334384 0.234375C6.1459384 -0.078125 6.6534381 -0.078125 6.9659381 0.234375L7.4334383 0.70437503C7.7459383 1.016875 7.7459383 1.524375 7.4334383 1.836875L4.5659385 4.7043748C4.2534385 5.0168748 3.7459383 5.0168748 3.4334383 4.7043748ZM6.0934381 6.1618748L5.3084383 5.3768749L8.1084385 2.576875L11.093438 5.5618749L8.293438 8.3618746L7.5084381 7.5768752L1.7084383 13.376875C1.3184383 13.766875 0.68593824 13.766875 0.29343826 13.376875C-0.09906175 12.986875 -0.096561752 12.354375 0.29343826 11.961875L6.0934381 6.1618748ZM8.9659386 10.234375C8.6534386 9.921875 8.6534386 9.4143753 8.9659386 9.1018753L11.833438 6.234375C12.145938 5.921875 12.653439 5.921875 12.965939 6.234375L13.433438 6.7018752C13.745938 7.0143752 13.745938 7.5218749 13.433438 7.8343749L10.565938 10.704375C10.253438 11.016875 9.7459383 11.016875 9.4334383 10.704375L8.9659386 10.236875L8.9659386 10.234375Z" />
                    </g>
                  </svg>

                  <span class="p-button-label">Browse Auctions</span>
                  <i class="pi pi-chevron-down ml-1"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Popup menu for Browse (items use routerLink) -->
        <p-tieredMenu #browseMenuRef [model]="browseMenu" [popup]="true" appendTo="body" [autoZIndex]="true"
          [baseZIndex]="11000">
        </p-tieredMenu>
      </div>

    </div>
  </div>
</div>

<!-- Category bar (desktop = equal columns; mobile = horizontal scroll) -->
<nav class="category-bar md:px-[3.5rem]" aria-label="Categories">
  <div class="cats container mx-auto ">
    <a *ngFor="let c of categoriesAll" class="cat !font-noto-serif" [routerLink]="getCatRouterLink(c)"
      [queryParams]="getCatQueryParams(c)">
      {{ c }}
    </a>
  </div>
</nav>